import script from "./PrescriptionForm.vue?vue&type=script&setup=true&lang=js"
export * from "./PrescriptionForm.vue?vue&type=script&setup=true&lang=js"

import "./PrescriptionForm.vue?vue&type=style&index=0&id=7fbd1920&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7fbd1920"]])

export default __exports__